//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import "./index.css"
import { Provider } from 'react-redux';
import initStore from './redux';
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={initStore}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
